module.exports = __webpack_public_path__ + "img/Saudi Arabia.103c47c0.svg";